import type { FunctionComponent } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { AdminAdvisoryNeeds } from './AdminAdvisoryNeeds';
import { AdminDocuments } from './AdminDocuments';
import { AdminDomiciles } from './AdminDomiciles';
import { AdminRootTopicEditor } from './AdminRootTopicEditor';
import { AdminTalkingPoints } from './AdminTalkingPoints';
import { AdminTools } from './AdminTools';
import { AdminTopics } from './AdminTopics';

export const ContentAdminRoutes: FunctionComponent = () => (
    <Routes>
        <Route index={true} element={<Navigate to="/content-admin" replace />} />
        <Route path="/wealth-planning/*" element={<Navigate to="/content-admin" replace />} />
        <Route path="/content-admin">
            <Route index={true} element={<Navigate to="topics" replace />} />
            <Route path="topics">
                <Route index={true} element={<AdminTopics />} />
                <Route path=":topicId" element={<AdminRootTopicEditor />} />
            </Route>
            <Route path="talking-points" element={<AdminTalkingPoints />} />
            <Route path="advisory-needs" element={<AdminAdvisoryNeeds />} />
            <Route path="documents" element={<AdminDocuments />} />
            <Route path="tools" element={<AdminTools />} />
            <Route path="domiciles" element={<AdminDomiciles />} />
        </Route>
    </Routes>
);
